module.exports = require('./helpers/bundle-url').getBundleURL('7pIAd') + "logo-dark.ba5147f0.svg";